import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'which_of_the_following_types_of_leave_is_the_fac_failing_to_pay'

export const dataPointDefinition = {
  retracedId: 'which_of_the_following_types_of_leave_is_the_fac_failing_to_pay',
  name: 'Which of the following types of leave is the facility failing to pay workers for, as legally required? (SELECT all that apply with a "X”)',
  description: '',
  meta: {},
  fieldTypeId: 'CHECK_BOX',
  type: 'RELATIONAL',
  options: [
    {
      key: 'ALL_PUBLIC_HOLIDAYS',
      text: 'All public holidays',
      externalIds: [
        {
          id: 'wb-wag-80x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'ANNUAL_LEAVE',
      text: 'Annual leave',
      externalIds: [
        {
          id: 'wb-wag-81x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'SICK_LEAVE',
      text: 'Sick leave',
      externalIds: [
        {
          id: 'wb-wag-82x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'MATERNITY_LEAVE',
      text: 'Maternity leave',
      externalIds: [
        {
          id: 'wb-wag-83x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'PATERNITY_LEAVE',
      text: 'Paternity leave',
      externalIds: [
        {
          id: 'wb-wag-84x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'PERSONAL_LEAVE',
      text: 'Personal leave',
      externalIds: [
        {
          id: 'wb-wag-85x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'VIETNAM_PAY_30_MINUTES_OF_TIME_OFF_PER_DAY_FOR_FEMALE_WORKERS_F',
      text: 'Vietnam: Pay 30 minutes of time off per day for female workers for rest during their period',
      externalIds: [
        {
          id: 'wb-wag-124x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'ETHIOPIA_PAY_WORKERS_CORRECTLY_DURING_PRENATAL_VISITS',
      text: 'Ethiopia: Pay workers correctly during prenatal visits',
      externalIds: [
        {
          id: 'wb-wag-125x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'ETHIOPIA_PAY_WORKERS_CORRECTLY_WHEN_THEY_TAKE_TIME_OFF_TO_APPEA',
      text: 'Ethiopia: Pay workers correctly when they take time off to appear at labor dispute hearings and to exercise their civil rights and duties',
      externalIds: [
        {
          id: 'wb-wag-126x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'OTHER_TYPES_OF_REQUIRED_LEAVE',
      text: 'Other types of required leave',
      externalIds: [
        {
          id: 'wb-wag-86x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'If other, please describe the TYPE of required leave that is not paid for:',
        externalIds: [
          {
            id: 'wb-wag-87f',
            version: '1.6.0',
            provider: 'slcp',
          },
        ],
      },
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              enum: [
                'ALL_PUBLIC_HOLIDAYS',
                'ANNUAL_LEAVE',
                'SICK_LEAVE',
                'MATERNITY_LEAVE',
                'PATERNITY_LEAVE',
                'PERSONAL_LEAVE',
                'VIETNAM_PAY_30_MINUTES_OF_TIME_OFF_PER_DAY_FOR_FEMALE_WORKERS_F',
                'ETHIOPIA_PAY_WORKERS_CORRECTLY_DURING_PRENATAL_VISITS',
                'ETHIOPIA_PAY_WORKERS_CORRECTLY_WHEN_THEY_TAKE_TIME_OFF_TO_APPEA',
                'OTHER_TYPES_OF_REQUIRED_LEAVE',
              ],
            },
            isChecked: {
              type: 'boolean',
            },
            followUp: {
              type: ['object', 'null'],
              properties: {
                value: {
                  type: 'string',
                },
              },
              required: ['value'],
            },
          },
          required: ['key', 'isChecked', 'followUp'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'wb-wag-79',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 9640,
  sectionId: '2.2.3',
  impactArea: 'Compensation',
  impactAreaId: 'WAGES_AND_BENEFITS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
